<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-row>
            <b-col md="9">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Territory Name</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="territory.territory_edit.TerritoryName"
                    placeholder="Territory Name"
                    required
                    autocomplete="off"
                    type="text"
                    id="TerritoryName"
                    v-on:keyup="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-radio-group
                class="mr-3"
                id="radiosBtn"
                buttons
                button-variant="outline-primary"
                v-model="territory.territory_edit.IsTemporary"
                name="radiosBtn"
              >
                <b-form-radio
                  class="mx-0 mediumStandardizedRadioWidth"
                  :value="true"
                  >Check Only</b-form-radio
                >
                <b-form-radio
                  class="mx-0 mediumStandardizedRadioWidth"
                  :value="false"
                  >Set To Active</b-form-radio
                >
              </b-form-radio-group>
            </b-col>
            <b-col md="3" v-if="false">
              <b-form-radio-group
                class="mr-3"
                id="radiosBtn"
                buttons
                button-variant="outline-primary"
                v-model="territory.territory_edit.IsProtected"
                name="radiosBtn"
              >
                <b-form-radio
                  class="mx-0 mediumStandardizedRadioWidth"
                  :value="true"
                  >Protected</b-form-radio
                >
                <b-form-radio
                  class="mx-0 mediumStandardizedRadioWidth"
                  :value="false"
                  >Shared</b-form-radio
                >
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <CoolSelect
                  width="100%"
                  v-model="territory.territory_edit.UserProfileID"
                  class="form-input dropdown-content"
                  placeholder="Type"
                  theme="bootstrap"
                  tooltip="Acount Manager"
                  :items="n_user.n_users"
                  item-text="UserName"
                  item-value="UserProfileID"
                  id="UserProfileID"
                >
                  <template slot="input-before">
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Account Manager</b-input-group-text
                      >
                    </b-input-group-prepend>
                  </template>
                </CoolSelect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Center Zip</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="territory.territory_edit.CenterZip"
                    placeholder="Account Zipcode"
                    required
                    autocomplete="off"
                    type="text"
                    id="CenterZip"
                    v-mask="'#####'"
                    v-on:keyup="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Default Radius</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="territory.territory_edit.DefaultRadius"
                    placeholder="Default Radius"
                    required
                    autocomplete="off"
                    type="text"
                    id="DefaultRadius"
                    v-mask="'###'"
                    v-on:keyup="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">
                      Color:
                      {{ territory.territory_edit.TerritoryColor }}
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-bind:style="{
                      backgroundColor: territory.territory_edit.TerritoryColor,
                      color: territory.territory_edit.TerritoryColor
                    }"
                    v-model="territory.territory_edit.TerritoryColor"
                    autocomplete="off"
                    type="text"
                    id="TerritoryColor"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="8" class="mb-5">
              <!-- <slider v-model="activeColor"></slider> -->
              <!-- <photoshop v-model="activeColor"></photoshop> -->
              <!-- <compact v-model="activeColor"></compact> -->
              <!-- <sketch v-model="activeColor"></sketch> -->
              <chrome v-model="activeColor"></chrome>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" class="mb-5">
              <div class="form-group form-actions" style="float: left">
                <router-link
                  v-if="territory.territory_edit.TerritoryID !== -1"
                  class="event-link"
                  to="/check-maps"
                >
                  <i
                    v-b-tooltip
                    title="Map Territory Check"
                    class="fa fa-globe fa-lg mt-1 mr-2 float-left clickIcon"
                  ></i>
                  <span class="eyebrow">Map Territory Check</span>
                </router-link>
              </div>
              <div class="form-group form-actions" style="float: right">
                <b-button
                  class="mr-2 mt-2"
                  size="md"
                  variant="outline-primary"
                  @click="back"
                >
                  <!-- <i class="fa fa-close"></i> -->
                  Close
                </b-button>
                <b-button
                  v-if="territory.territory_edit.TerritoryID !== -1"
                  :disabled="
                    isClean || territory.territory_edit.CenterZip.length != 5
                  "
                  class="mr-0 mt-2"
                  size="md"
                  variant="primary"
                  type="submit"
                >
                  <i class="fa fa-save"></i>
                  Save
                </b-button>
                <b-button
                  v-if="territory.territory_edit.TerritoryID === -1"
                  :disabled="
                    isClean || territory.territory_edit.CenterZip.length != 5
                  "
                  class="mr-0 mt-2"
                  size="md"
                  variant="primary"
                  type="submit"
                >
                  <i class="fa fa-plus"></i>
                  Create Territory Check
                </b-button>
              </div>
              <div class="form-group form-actions" style="float: right">
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismissCountDown"
                  fade
                  variant="light"
                  :dismissed="(dismissCountdown = 0)"
                  @dismiss-count-down="countDownChanged"
                >
                  Your information has been saved
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismiss2CountDown"
                  fade
                  variant="danger"
                  :dismissed="(dismiss2Countdown = 0)"
                  @dismiss-count-down="countDown2Changed"
                >
                  Your information could not be saved. Check all fields
                  carefully.
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
              </div>
            </b-col>
          </b-row>

          <b-row
            class="primary-row divider-row"
            v-if="territory.territory_edit.TerritoryID !== -1"
          >
            <b-col md="8" class="text-left">
              <span class="icon-small">
                <i
                  v-if="!show_zips"
                  class="fa fa-plus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="show_zips = !show_zips"
                ></i>
                <i
                  v-if="show_zips"
                  class="fa fa-minus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="show_zips = !show_zips"
                ></i>
                <h4 class="display-4 drtext">Zips</h4>
              </span>
            </b-col>

            <b-col md="3" style="float: right">
              <h4 class="display-4 drtext-small">
                Total Quantity: {{ ZipTotal }}
              </h4>
            </b-col>
            <b-col md="1">
              <span class="icon-small">
                <i
                  class="fa fa-download fa-lg mt-3 pt-0 ml-0 clickIcon"
                  style="color: #555;"
                  @click="my_download"
                ></i>
              </span>
            </b-col>
          </b-row>

          <b-row class="mt-5"></b-row>

          <TerritoryZipContainer
            v-if="show_zips"
            :territory_object="territory.territory_edit"
          />

          <b-row
            class="primary2-row divider-row"
            v-if="territory.territory_edit.TerritoryID !== -1"
          >
            <b-col md="9" class="text-left">
              <span class="icon-small">
                <i
                  v-if="!show"
                  class="fa fa-plus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="show = !show"
                ></i>
                <i
                  v-if="show"
                  class="fa fa-minus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="show = !show"
                ></i>
                <h4 class="display-4 drtext">Clusters</h4>
              </span>
            </b-col>

            <b-col md="3" style="float: right">
              <div class="form-group form-actions" style="float: right">
                <b-button
                  v-if="territory.territory_edit.TerritoryID !== -1"
                  class="mr-2 mt-2"
                  size="md"
                  variant="primary"
                  @click="addRotation"
                  style="
                    background-color: rgba(32, 216, 93, 0.85);
                    border-color: rgba(32, 216, 93, 0.95);
                    width: 150px;
                  "
                  >Add Cluster</b-button
                >
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-5"></b-row>

          <RotationRow
            v-if="show"
            v-for="rotation in territory.territory_edit.Rotations"
            :key="rotation.RotationID"
            :rotation_object="rotation"
            :territory_object="territory.territory_edit"
            @DeleteRotation="deleteRotation"
          />

          <b-row class="primary3-row divider-row" v-if="false">
            <b-col md="9" class="text-left">
              <span class="icon-small">
                <i
                  v-if="!show2"
                  class="fa fa-plus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="show2 = !show2"
                ></i>
                <i
                  v-if="show2"
                  class="fa fa-minus-circle fa-lg mt-0 pt-0 mr-2 clickIcon"
                  style="color: #555"
                  @click="show2 = !show2"
                ></i>
                <h4 class="display-4 drtext">Contacts</h4>
              </span>
            </b-col>

            <b-col v-if="false" md="3" style="float: right">
              <div class="form-group form-actions" style="float: right">
                <b-button
                  v-if="territory.territory_edit.TerritoryID !== -1"
                  class="mr-2 mt-2"
                  size="md"
                  variant="primary"
                  style="
                    background-color: rgba(216, 142, 32, 0.85);
                    border-color: rgba(216, 142, 32, 0.95);
                    width: 150px;
                  "
                  @click="newTerritoryContactEntity"
                  >Add Contact</b-button
                >
              </div>
            </b-col>
          </b-row>
          <TerritoryContactListSub v-if="show2" />
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CoolSelect } from "vue-cool-select";
import { Slider, Photoshop, Compact, Sketch, Chrome } from "vue-color";
import { required, email, helpers } from "vuelidate/lib/validators";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
import RotationRow from "@/components/CustomRowComponents/RotationRowCheck.vue";
import TerritoryZipContainer from "@/components/CustomSubComponents/TerritoryZipContainer.vue";
import TerritoryContactListSub from "@/components/SubListComponents/TerritoryContactsListSub.vue";

//import TerritoryEsriMap from "@/components/maps/TerritoryEsriMap.vue";

export default {
  name: "TempTerritoryProfile",
  components: {
    TerritoryZipContainer,
    Chrome,
    CoolSelect,
    Sketch,
    Slider,
    Compact,
    Photoshop,
    RotationRow,
    TerritoryContactListSub
  },
  computed: {
    ...mapState(["territory", "seminar", "n_user", "saveOp"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },
    ZipTotal() {
      var _st = 0;
      this.$store.state.territory.territory_edit.Zips.forEach(zip => {
        _st += zip.Quantity;
      });
      return _st;
    }
  },
  created() {
    this.$store.dispatch("n_user/fetchUsers");
    this.activeColor.hex = this.$store.state.territory.territory_edit.TerritoryColor;

    this.addDirtyFieldWatch("IsTemporary", true);
    // this.$store.state.territory.territory_edit.TerritoryColor = {
    //   hex: this.$store.state.territory.territory_edit.TerritoryColor
    // };
  },
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: false,
      show2: false,
      show_zips: false,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      showDismissibleAlert: false,
      activeColor: {}
    };
  },
  methods: {
    my_download() {
      this.$store
        .dispatch(
          "territory/DownloadTerritoryZips",
          this.$store.state.territory.territory_edit
        )
        .then(response =>
          window.open(
            "http://rm_api.revolutionterritorymanager.com/Output/" +
              response.data["ExportZipsResult"],
            "_blank"
          )
        );
    },
    deleteRotation(rotation) {
      this.$store
        .dispatch("territory/DeleteRotation", rotation)
        .then(
          (this.$store.state.territory.territory_edit.Rotations = this.$store.state.territory.territory_edit.Rotations.filter(
            del => del.RotationID !== rotation.RotationID
          ))
        );
    },
    addRotation() {
      this.$store.state.territory.territory_edit.Rotations.push(
        this.createFreshObject()
      );
    },
    createFreshObject() {
      return {
        RotationID: -1,
        RotationName: "New",
        TerritoryID: this.$store.state.territory.territory_edit.TerritoryID,
        RotationColor: "#FFFFEE"
      };
    },
    newTerritoryContactEntity() {
      this.$store
        .dispatch(
          "seminar/newTerritoryContact",
          this.createFreshTerritoryContactObject()
        )
        .then(() => {
          this.$router.push({ name: "TerritoryContactProfile" });
          //,
          //params: { id: this.event.id }
        })
        .catch(error => {
          console.log(error.message);
          //.dispatch('notification/add', this.event)
        });
    },
    createFreshTerritoryContactObject() {
      return {
        TerritoryContactID: -1,
        TerritoryID: this.$store.state.territory.territory_edit.TerritoryID
      };
    },
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    save() {
      var _symbol_check = this.$store.state.zip.zip_symbols.find(
        zs =>
          zs.TerritoryID ===
          this.$store.state.territory.territory_edit.TerritoryID
      );

      if (_symbol_check) {
        this.$store.state.zip.zip_symbols.find(
          zs =>
            zs.TerritoryID ===
            this.$store.state.territory.territory_edit.TerritoryID
        ).SymbolColor = this.$store.state.territory.territory_edit.TerritoryColor;
      }
      // else
      // {
      //   var _newSymbol =
      //   {
      //   "IsProtected": this.$store.state.territory.territory_edit.IsProtected,
      //   "SymbolColor": this.$store.state.territory.territory_edit.TerritoryColor,
      //   "TerritoryID": this.$store.state.territory.territory_edit.TerritoryID,
      //   "TerritoryName": this.$store.state.territory.territory_edit.TerritoryName,
      //   "ZipCode": this.$store.state.territory.territory_edit.CenterZip
      //   }
      //   this.$store.state.zip.zip_symbols.push(_newSymbol);
      // }

      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store.state.saveOp.localUrl = "/Territory/SaveTerritory/";
        this.$store.state.saveOp.localVariableName = "_t";
        this.$store.state.saveOp.localVariableObject = {
          TerritoryID: this.$store.state.territory.territory_edit.TerritoryID,
          UserProfileID: this.$store.state.territory.territory_edit
            .UserProfileID
        };
        this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
        this.$store.state.saveOp.localFieldToSet = "TerritoryID";
        this.$store.state.saveOp.localReturnObject = "SaveTerritoryResult";
        //this.$store.state.n_user.n_user_edit[:UserProfileID];

        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = [])(
                  (this.dismissCountDown = this.dismissSecs)
                )(this.$store.state.saveOp.DestroySaveOperation)
              )
          );

        // this.$store
        // .dispatch("territory/pushLocalObject", this.$store.state.territory.territory_edit)
        // ;
        // this.$store
        //   .dispatch("saveOp/BuildSaveOperation")
        //   .then(this.$store.dispatch.dispatch("saveOp/EmitSave"))
        //   .then(
        //     (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
        //   );
      }
    },
    addDirtyField: function(event) {
      if (event.which !== 9 && event.which !== 13) {
        this.dirtyFields = this.dirtyFields.filter(
          dirtyField => dirtyField.FieldName !== event.target.id
        );
        this.dirtyFields.push({
          FieldName: event.target.id,
          FieldValue: event.target.value
        });
        //console.log(this.dirtyFields.length);
      }
    },
    addDirtyFieldRadio: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== "IsSU"
      );
      this.dirtyFields.push({
        FieldName: "IsSU",
        FieldValue: event.target.value
      });
      //console.log(this.dirtyFields.length);
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    }
  },
  watch: {
    "$store.state.territory.territory_edit.UserProfileID": function() {
      this.addDirtyFieldWatch(
        "UserProfileID",
        this.$store.state.territory.territory_edit.UserProfileID
      );
    },
    "$store.state.territory.territory_edit.TerritoryID": function(newValue) {},
    "$store.state.territory.territory_edit.TerritoryColor": function(
      newValue
    ) {},
    "$store.state.territory.territory_edit.IsProtected": function() {
      this.addDirtyFieldWatch(
        "IsProtected",
        this.$store.state.territory.territory_edit.IsProtected
      );
    },
    activeColor: function(newValue, oldValue) {
      this.$store.state.territory.territory_edit.TerritoryColor = newValue.hex;
      this.addDirtyFieldWatch("TerritoryColor", newValue.hex);
    }
  },

  validations: {
    territory: {
      territory_edit: {
        TerritoryName: {
          required
        }
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
.icon-small {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
